import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  LANDING_SECTION_IDS,
  SALES_PHONE,
  SALES_PHONE_DISPLAY,
  scrollToSection,
} from './constants';

interface CtaBandSectionProps {
  isAuthenticated: boolean;
}

export function CtaBandSection({ isAuthenticated }: CtaBandSectionProps) {
  return (
    <section className="py-20">
      <div className="container px-6 mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative overflow-hidden rounded-3xl border border-primary/20 bg-gradient-to-r from-primary/10 via-primary/5 to-primary/10 px-8 py-12 sm:px-12 sm:py-16 text-center"
        >
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-primary/5 to-transparent pointer-events-none" />
          <div className="relative space-y-6 max-w-2xl mx-auto">
            <h2 className="text-3xl sm:text-4xl font-black tracking-tight text-foreground">
              Ready to grow your community?
            </h2>
            <p className="text-muted-foreground text-lg">
              Start building today or talk to our team for a personalized walkthrough.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to={isAuthenticated ? '/dashboard' : '/login'}>
                <Button
                  size="lg"
                  className="h-12 px-8 rounded-full font-semibold shadow-lg shadow-primary/20"
                >
                  {isAuthenticated ? 'Go to Dashboard' : 'Get Started'}
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <Button
                size="lg"
                variant="outline"
                className="h-12 px-8 rounded-full font-semibold"
                onClick={() => scrollToSection(LANDING_SECTION_IDS.contact)}
              >
                Request Demo
              </Button>
            </div>
            <a
              href={`tel:${SALES_PHONE}`}
              className="inline-flex items-center gap-2 text-sm font-medium text-foreground hover:text-primary transition-colors"
            >
              <Phone className="h-4 w-4 text-primary" />
              {SALES_PHONE_DISPLAY}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
